'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.configQuery = void 0;
var magic_messages_1 = require("@gig/magic-messages");
function configQuery(path, callback) {
    if (callback) {
        window.queryBus.query(magic_messages_1.CONFIG_QUERY, path, callback);
    }
    return window.queryBus.query(magic_messages_1.CONFIG_QUERY, path);
}
exports.configQuery = configQuery;
